(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/sportkryss.js') >= 0) return;  svs.modules.push('/modules/tipset/views/sportkryss.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.sportkryss = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"betslipSportkryss\"></div>";
},"useData":true});
Handlebars.partials['svs-tipset-sportkryss'] = svs.tipset.templates.sportkryss;
})(svs, Handlebars);

 })(window);